import React from "react";
import styles from "./summaryInfo.scss";

const SummaryInfo = ({ adSummary, showViewedCount }) => (
  <div className={styles.info}>
    <span className={styles.title}>{adSummary.title}</span>
    {adSummary.postedTime && (<span>{`${"Objavljen"}: ${adSummary.postedTime}`}</span>)}
    {adSummary.renewalTime && (<span className={styles.renewalTime}>{`${"Obnovljen"}: ${adSummary.renewalTime}`}</span>)}
    <span
      className={styles.code}
    >{`${"Kod"}: ${adSummary.code}`}</span>
    {showViewedCount ? (
      <span className={styles.viewedCount}>
        {"Prikazan: {0} puta".replace("{0}", String(adSummary.viewCount))}
      </span>
    ) : null}
  </div>
);

export default SummaryInfo;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/SummarySection/SummaryInfo/index.tsx